module.exports = __webpack_public_path__ + "static/img/logo.5e84705.svg";